import React from 'react';

/**
 * Button/CTA block — email-safe button preview.
 */
export default function EmailButtonBlock({ props, onChange, isSelected }) {
  return (
    <div style={{ padding: props.outer_padding || '16px 24px', textAlign: props.alignment || 'center' }}>
      <a
        href={props.href || '#'}
        onClick={e => e.preventDefault()}
        style={{
          display: 'inline-block',
          padding: `${props.padding_y || '12px'} ${props.padding_x || '24px'}`,
          backgroundColor: props.bg_color || '#1c1917',
          color: props.text_color || '#ffffff',
          textDecoration: 'none',
          borderRadius: props.border_radius || '6px',
          fontSize: props.font_size || '14px',
          fontWeight: 600,
          cursor: 'default',
          width: props.width === 'full' ? '100%' : props.width === 'auto' ? 'auto' : props.width,
          textAlign: 'center',
          boxSizing: 'border-box',
        }}
      >
        {props.text || 'Click Here'}
      </a>
    </div>
  );
}
